import { render } from "./Lights.vue?vue&type=template&id=27dabb97"
import script from "./Lights.vue?vue&type=script&lang=js"
export * from "./Lights.vue?vue&type=script&lang=js"

import exportComponent from "C:\\raro\\raro-web\\argon-cel\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__